import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './view-more-reports.module.scss';
import CustomAntModal from '../../../../components/CustomAntModal/CustomAntModal';
import talentProfileApi from '../../../../services/talentProfiles';
import file from '../../../../assets/img/fileIcon.svg';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';

const ViewMoreReports = ({ open, setOpen, staffId, setSelected }) => {
  const { roleId } = useSelector((state) => state.user.roleActive);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedStaffId, setFetchedStaffId] = useState(null);

  useEffect(() => {
    if (!staffId || !open || fetchedStaffId === staffId) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await talentProfileApi.getReports(roleId, staffId, true);
        if (res.status === 200) {
          setData(res.data.result);
          setFetchedStaffId(staffId);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [roleId, staffId, open]);
  return (
    <CustomAntModal hideDefaultBtn width={1000} open={open} setOpen={setOpen} closeType={1}>
      <div className={styles.wrapper}>
        <div className={styles.title}>Reports</div>
        <Spin spinning={loading}>
          <div className={styles.reports}>
            {data.map((report) => (
              <div key={report.id} className={styles.report} onClick={() => setSelected(report)}>
                <div className={styles.fileIcon}>
                  <img src={file} alt="" width="17" height="22" />
                </div>
                <div className={styles.name}>{`${report.staff_id}_BePCB Report_FY${report.year}`}</div>
              </div>
            ))}
          </div>
        </Spin>
      </div>
    </CustomAntModal>
  );
};

export default ViewMoreReports;

ViewMoreReports.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  staffId: PropTypes.string,
  setSelected: PropTypes.func,
};
